// Sentry Tag Keys
// This is to ensure that we can reliably search for these tags across the various clients.
export const SENTRY_SCHOOL_NAME = 'sparx.school.name';
export const SENTRY_SCHOOL_DISPLAY_NAME = 'sparx.school.display_name';
